<template>
  <div class="layout-root">
    <div class="layout-bar text-center">
      <router-link to="/" class="ml-3 h-100 d-inline-flex align-items-center">
        <img src="../../assets/Kingsland_Seal_White.png" alt="Kingsland Logo" />
      </router-link>
    </div>
    <slot />
  </div>
</template>

<script>
  export default {
    name: "DefaultLayout"
  }
</script>

<style lang="scss" scoped>
  .layout-root {
    padding-top: 4rem;
  }

  .layout-bar {
    background: #211f47;
    width: 100%;
    height: 4rem;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    img {
      height: 75%;
      width: auto;
    }
  }
</style>